import { Injectable } from '@angular/core';

import { ApplicationService, AuthenticationService, BaseService, ConfigService, ErrorService, LoggingService } from '@pit/core';
import { PinItTrackFrontendDeviceService } from '../../services/implementations/pin.it.track.frontend.device.service';
import { IPinItTrackFrontendApplicationService } from '../../services/interfaces/pin.it.track.frontend.application.service.interface';
import { IPinItTrackFrontendAuthenticationService } from '../../services/interfaces/pin.it.track.frontend.authentication.service.interface';
import { IPinItTrackFrontendDeviceService } from '../../services/interfaces/pin.it.track.frontend.device.service.interface';
import { IPinItTrackFrontendErrorService } from '../../services/interfaces/pin.it.track.frontend.error.service.interface';
import { IPinItTrackFrontendCoreServicesAccessor } from '../interfaces/pin.it.track.frontend.core.services.accessor.interface';


@Injectable({
    providedIn: 'root'
})
export class PinItTrackFrontendCoreServicesAccessor extends BaseService implements IPinItTrackFrontendCoreServicesAccessor {

    constructor(configurationService: ConfigService, loggingService: LoggingService,
        applicationService: ApplicationService, authenticationService: AuthenticationService,
        deviceService: PinItTrackFrontendDeviceService, errorService: ErrorService,) {
        super(configurationService, loggingService, false);

        this.applicationService = ((applicationService as any) as IPinItTrackFrontendApplicationService);
        this.authenticationService = ((authenticationService as any) as IPinItTrackFrontendAuthenticationService);
        this.deviceService = deviceService;
        this.errorService = ((errorService as any) as IPinItTrackFrontendErrorService);
    }

    public readonly applicationService: IPinItTrackFrontendApplicationService = null;

    public readonly authenticationService: IPinItTrackFrontendAuthenticationService = null;

    public readonly deviceService: IPinItTrackFrontendDeviceService = null;

    public readonly errorService: IPinItTrackFrontendErrorService = null;

    protected override async doInitializeAsync(): Promise<void> {
        await super.doInitializeAsync();

        if (this.isInitialized === false) {
            await this.applicationService.initializeAsync();
            await this.deviceService.initializeAsync();
            await this.authenticationService.initializeAsync();
        }
    }

}
